const buildOrganizationSchema = siteUrl => {
  if (!siteUrl) return null;

  const origin = siteUrl.replace(/\/$/, '');
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Rentzy',
    url: origin,
    logo: `${origin}/icons/icon-512x512.png`,
  };
};

export default buildOrganizationSchema;
